import React, { useEffect, useState } from "react";
import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  List,
  Typography,
  Box,
} from "@mui/material";
import { NavLink, useLocation } from "react-router";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

const ACTIVE_BG = "#FAB306";
const HOVER_BG = "#F6F6F6";

const RenderMenuItem = ({ item }: { item: any }) => {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const isAnyChildActive = item.children?.some(
    (child: any) =>
      location.pathname === child.to ||
      location.pathname.startsWith(child.to + "/")
  );

  useEffect(() => {
    setOpen(!!isAnyChildActive);
  }, [isAnyChildActive]);

  // ---------- Parent with children ----------
  if (item.children?.length) {
    return (
      <React.Fragment key={item.label}>
        <ListItemButton
          onClick={() => setOpen((prev) => !prev)}
          sx={{
            my: 0.5,
            px: 1.5,
            py: 1,
            mx: 1,
            borderRadius: 2.5,
            backgroundColor: "transparent",
            color: "#141417",
            "&:hover": { backgroundColor: HOVER_BG },
          }}
        >
          {item.icon && (
            <ListItemIcon sx={{ minWidth: 36 }}>
              {item.icon}
            </ListItemIcon>
          )}

          <ListItemText
            primary={
              <Typography fontSize={14} fontWeight={600}>
                {item.label}
              </Typography>
            }
          />

          {open ? (
            <ExpandLessIcon fontSize="small" />
          ) : (
            <ExpandMoreIcon fontSize="small" />
          )}
        </ListItemButton>

        <Collapse in={open} timeout="auto" unmountOnExit>
          <List disablePadding sx={{ mt: 0.5 }}>
            {item.children.map((child: any) => {
              const isChildActive =
                location.pathname === child.to ||
                location.pathname.startsWith(child.to + "/");

              return (
                <ListItemButton
                  key={child.label}
                  component={NavLink}
                  to={child.to}
                  sx={{
                    my: 0.25,
                    ml: 2.5,      // indent children
                    mr: 1,
                    px: 2,
                    py: 0.9,
                    borderRadius: 2.5,
                    backgroundColor: isChildActive ? ACTIVE_BG : "transparent",
                    color: isChildActive ? "#111" : "#444",
                    fontWeight: isChildActive ? 700 : 500,
                    "&:hover": {
                      backgroundColor: isChildActive ? ACTIVE_BG : HOVER_BG,
                    },
                  }}
                >
                  <ListItemText
                    primary={
                      <Typography fontSize={14}>
                        {child.label}
                      </Typography>
                    }
                  />
                </ListItemButton>
              );
            })}
          </List>
        </Collapse>
      </React.Fragment>
    );
  }

  // ---------- Single item ----------
  const isActive =
    location.pathname === item.to ||
    location.pathname.startsWith(item.to + "/");

  return (
    <ListItemButton
      key={item.label}
      component={NavLink}
      to={item.to}
      sx={{
        my: 0.5,
        px: 2,
        py: 1,
        mx: 1,
        borderRadius: 2.5,
        backgroundColor: isActive ? ACTIVE_BG : "transparent",
        color: isActive ? "#111" : "#444",
        fontWeight: isActive ? 700 : 500,
        "&:hover": {
          backgroundColor: isActive ? ACTIVE_BG : HOVER_BG,
        },
      }}
    >

      {item.icon && (
        <ListItemIcon sx={{ minWidth: 36 }}>
          {item.icon}
        </ListItemIcon>
      )}

      <ListItemText
        primary={
          <Typography fontSize={14}>
            {item.label}
          </Typography>
        }
      />
    </ListItemButton>
  );
};

export default RenderMenuItem;
